import { generatePath, useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { CALENDAR_DAY_ROUTE } from "../../../app/router/routes";
import { ICalendarFilter } from "../../../entities/calendar";
import { CalendarMonth } from "../../../widgets/calendarMonth";

interface ICalendarOutletContext {
    filter: ICalendarFilter;
}

const getDateParam = (date: Date): string => {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
}

export default function CalendarMonthPage() {

    const {filter} = useOutletContext<ICalendarOutletContext>()
    const navigate = useNavigate()
    const location = useLocation()

    const openDay = (date: Date) => {
        navigate({
            pathname: generatePath(CALENDAR_DAY_ROUTE.path, {
                date: getDateParam(date),
            }),
            search: location.search,
        })
    }

    return <CalendarMonth filter={filter} onSelectDate={openDay} />
}
